// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__33db9","inputWrap":"styles_inputWrap__IZymu","input":"styles_input__1aodD"};